import _styled from "styled-components";
import React from 'react';
import PropTypes from 'prop-types';
import EmptyState from '@adsk/alloy-react-empty-state';
import { useLocale } from '@adsk/alloy-react-locale';
import ConnectedTopNavigationOptionalUser from './ConnectedTopNavigationOptionalUser';
import NavigationLayout from './NavigationLayout';
const NoAccessPage = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    onLogout
  } = _ref;
  const {
    T
  } = useLocale(_ref2 => {
    let {
      locale
    } = _ref2;
    return require("./i18n/".concat(locale, ".json"));
  });
  return /*#__PURE__*/React.createElement(NavigationLayout, {
    ref: ref,
    renderSideNavigation: () => null,
    renderTopNavigation: () => /*#__PURE__*/React.createElement(ConnectedTopNavigationOptionalUser, {
      onLogout: onLogout
    })
  }, /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css: [{
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }]
  }, /*#__PURE__*/React.createElement(EmptyState, {
    size: EmptyState.SIZES.LARGE,
    illustrationType: EmptyState.ILLUSTRATION_TYPES.PEOPLE_UPPER_BODY_GREY,
    title: T.translate('NO_ACCESS_TITLE'),
    description: T.translate('NO_ACCESS_DESCRIPTION')
  })));
});
NoAccessPage.displayName = 'NoAccessPage';
NoAccessPage.propTypes = {
  /** callback called on logout */
  onLogout: PropTypes.func
};
export default NoAccessPage;
var _StyledDiv = _styled("div").withConfig({
  displayName: "NoAccessPage___StyledDiv",
  componentId: "sc-1e9dnil-0"
})(["", ""], p => p.$_css);
//# sourceMappingURL=NoAccessPage.js.map